import {
  DO_LOADING, DO_SWITCH_OFF, DO_SWITCH_ON, DO_TRIGGER,
} from 'redux/actions/loading';

import { InitialStateboard } from 'components/transformLoader/boardList';
import { initialStateDashboard } from 'components/transformLoader/dashboard';
import { initialStateCompany } from 'components/transformLoader/company';
import { initialStateOrganization } from 'components/transformLoader/organization';
import { initialStateJobDesc } from 'components/transformLoader/jobDesc';
import { initialStateAnalytics } from 'components/transformLoader/wlaAnalytics';
import { initialStateMonitor } from 'components/transformLoader/wlaMonitoring';
import { initialStateMatrix } from 'components/transformLoader/matrix';
import { InitialStateBackOffice } from 'components/transformLoader/BackOffice';

const random = Math.random()?.toString(36).slice(-5);
const initialState = {
  loading: false,
  trigger: random,
  listKey: {
    ...InitialStateboard,
    ...initialStateDashboard,
    ...initialStateCompany,
    ...initialStateOrganization,
    ...initialStateJobDesc,
    ...initialStateAnalytics,
    ...initialStateMonitor,
    ...initialStateMatrix,
    ...InitialStateBackOffice,
  },
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DO_LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }
    case DO_TRIGGER: {
      return {
        ...state,
        trigger: payload,
      };
    }
    case DO_SWITCH_ON: {
      if (payload !== undefined) {
        return {
          ...state,
          listKey: {
            ...state.listKey,
            [payload]: true,
          },
        };
      }
      return state;
    }
    case DO_SWITCH_OFF: {
      if (payload !== undefined) {
        return {
          ...state,
          listKey: {
            ...state.listKey,
            [payload]: false,
          },
        };
      }
      return state;
    }

    default:
      return state;
  }
};
